import { useDispatch, useSelector } from "react-redux";
import { updateSecondStepGeneralsNestedFields } from "../../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../../redux/reducers/claimFieldErrorsReducer";
import { shouldRenderSpecField } from "../../../../../../redux/reducers/visibilityMatrixesReducer";
import { StoreType } from "../../../../../../redux/store/store";
import CountryAutocompleteField from "../../../../../../Components/CustomInputs/CountryAutocompleteField";

const ThroutfulPersonCountryField = () => {
   const dispatch = useDispatch();
   const fieldNameLowerCase = "throutfulPersonCountry";
   const fieldNameUpperCase = "ThroutfulPersonCountry";
   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.personModel.personThroutful.throutfulPersonCountry
   );
   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );
   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   return (
      <CountryAutocompleteField
         labelText="Země"
         placeholderText="Uveďte zemi"
         value={fieldValue}
         validationText={handleShowErrorMessage(
            fieldNameUpperCase,
            claimFieldErrorsMessages
         )}
         dependencyValue={shouldRenderSpecField(
            "GeneralFields",
            fieldNameUpperCase,
            visibilityMatrixes
         )}
         fieldNameForScroll={fieldNameUpperCase}
         onChange={(value) =>
            dispatch(
               updateSecondStepGeneralsNestedFields({
                  value,
                  sectionName: "personThroutful",
                  field: fieldNameLowerCase,
               })
            )
         }
      />
   );
};

export default ThroutfulPersonCountryField;
